import React from "react";
import Navbar from "./Components/Navbar/Navbar";
import HeroSection from "./Components/HeroSection/HeroSection";
import Features from "./Components/Features/Features";
import About from "./Components/About/About";
import ExploreFields from "./Components/ExploreFields/ExploreFields";
import QcreativesFor from "./Components/QcreativesFor/QcreativesFor";
import Footer from "./Components/Footer/Footer";

const Landing = (props) => {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <Features />
      <About />
      <ExploreFields />
      <QcreativesFor />
      <Footer {...props} />
    </main>
  );
};

export default Landing;
